import React, { FC } from 'react';

interface IField {
  field: {
    name: string;
    value: string;
  };
}

const TextArea: FC<IField> = ({ field, ...props }) => {
  return <textarea rows={5} {...field} {...props}/>;
};

export default TextArea;
